// nasolabialFillersData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}
interface internalLinking {
    heading: string;
    items: [] | any;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    internalLinking: internalLinking;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const nasolabialFillers: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Nasolabial Fold Filler Dubai | Elite Body Home Polyclinic",
            "description": "Get Nasolabial Fold Filler in Dubai, a non-surgical treatment to reduce deep lines and restore youthful skin. Enjoy natural-looking results. FREE Consultation.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/nasolabial-fold-filler/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Nasolabial Fold Filler Dubai | Elite Body Home Polyclinic",
                "description": "Get Nasolabial Fold Filler in Dubai, a non-surgical treatment to reduce deep lines and restore youthful skin. Enjoy natural-looking results. FREE Consultation.",
                "url": "https://elitebodyhome.com/nasolabial-fold-filler/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2024-12-30T10:40:43+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-99.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-99.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Nasolabial Fold Filler",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Nasolabial Fold Filler Dubai | Elite Body Home Polyclinic",
                "description": "Get Nasolabial Fold Filler in Dubai, a non-surgical treatment to reduce deep lines and restore youthful skin. Enjoy natural-looking results. FREE Consultation.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-99.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Nasolabial Fold Filler"],
        "hero": {
            "title": "Nasolabial Fold Filler in Dubai",
            "subtitle": "Say Goodbye to Deep Smile Lines",
            "description": "Nasolabial folds, commonly known as the \"smile lines\" or the \"laugh lines,\" are the deep creases that run between the sides of your nose and the corners of your mouth. With time, these lines may become deeper due to the aging of the skin and sun exposure, along with a loss of collagen. If you want to smooth out these folds and restore your youthful look, Nasolabial Fold Fillers are a quick and effective procedure."
        },
        "howItWorks": {
            "title": "What Are Fillers for Nasolabial Folds?",
            "description": "Nasolabial fold fillers are injectable treatments aimed at restoring volume and smoothing deep lines around the nose and mouth. These fillers are composed of hyaluronic acid, a substance that is naturally found within the body, adding hydration and plumping to the skin. Elite Body Home uses the highest quality fillers: Juvederm, Restylane, and other FDA approved brands to ensure the best and longest lasting results."
        },
        "procedureSteps": {
            "heading": "Nasolabial Fold Filler Procedure Steps",
            "para": "",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "To assess the best filler and treatment plan for you, the specialist will evaluate your nasolabial folds, skin condition, and facial structure during the consultation.",
                    "icon": "fa-regular fa-comment-dots"
                },
                {
                    "title": "Preparation",
                    "desc": "This helps to ensure the area around the nasolabial folds is clean and prevents any infection. You will then have a topical numbing cream applied to the area to eliminate any discomfort during surgery.",
                    "icon": "fa-regular fa-hand-sparkles"
                },
                {
                    "title": "Injections",
                    "desc": "This will allow the practitioner to mark the areas that need to be injected with filler.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Massage & Shaping",
                    "desc": "The practitioner may also gently massage the injection site after the procedure to help disperse the filler evenly and ensure that it camouflages smoothly into your natural facial structure.",
                    "icon": "fa-regular fa-hand-spock"
                },
                {
                    "title": "Filler Injections",
                    "desc": "The dermal filler is carefully injected into the areas marked on the nasolabial folds using a fine needle or cannula.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Final Assessment",
                    "desc": "As soon as the filler is added, the professional will evaluate the results and add a touch if needed. You will be provided with post-treatment directives to achieve proper healing for the best possible outcome.",
                    "icon": "fa-regular fa-clipboard-check"
                }
            ]
        },
        "benefits": {
            "heading": "What Are The Advantages Of Nasolabial Fold Filler Treatment",
            "subheading": "",
            "para": "My nasolabial fold filler came home at a lower cost, and the benefits went beyond just lines being filled. This treatment offers a refreshed, more youthful appearance with little recovery time.",
            "items": [
                {
                    "title": "Immediate Results",
                    "desc": "See a visible reduction in smile lines immediately following your treatment.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Minimally Invasive",
                    "desc": "The entire procedure is non-invasive, with no incisions or surgery, and minimum downtime.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "Natural, Youthful Look",
                    "desc": "Fillers offer subtle, natural-looking augmentations that give facial volumization without making you look overdone!",
                    "icon": "fa-regular fa-face-smile"
                },
                {
                    "title": "Customizable to Your Needs",
                    "desc": "This allows for more precise contouring, as well as individualized placement of filler and injectables to complement your specific facial structure and desires.",
                    "icon": "fa-solid fa-sliders"
                },
                {
                    "title": "Quick Procedure",
                    "desc": "Treatment is usually finished in less than 30 minutes, to suit busy lifestyles.",
                    "icon": "fa-regular fa-clock"
                },
                {
                    "title": "Long-Lasting Effects",
                    "desc": "Depending on the filler, results can range from six to 18 months for long-lasting rejuvenation.",
                    "icon": "fa-solid fa-hourglass-end"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "Although fillers for nasolabial folds are safe for most people, you should make sure you're a good candidate.",
            "items": [
                {
                    "title": "Patients with moderate to severe nasolabial folds",
                    "desc": "If the lines around your mouth and nose are something that are causing you concern, this treatment may be for you.",
                    "icon": "fa-solid fa-face-meh"
                },
                {
                    "title": "Healthy Adults",
                    "desc": "Patients must be in good overall health, without conditions that could impede healing.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "Current non-smokers or people who are willing to quit smoking",
                    "desc": "Smoking can also hinder healing of the treatment area.",
                    "icon": "fa-solid fa-smoking-ban"
                },
                {
                    "title": "Realistic expectations",
                    "desc": "Patients should understand that fillers — while impressive — are not limitless and they're temporary.",
                    "icon": "fa-solid fa-scale-balanced"
                },
                {
                    "title": "Non-pregnant and non-breastfeeding individuals",
                    "desc": "One big reason dermal fillers should be avoided during pregnancy and breastfeeding is the absence of safety data on their use during these periods.",
                    "icon": "fa-solid fa-baby-carriage"
                }
            ]
        },
        "internalLinking": {
            "heading": "Explore Our Dermal Fillers for Complete Facial Enhancement",
            "items": [{ "name": "Chin Fillers", "link": "/services/chin-fillers-dubai" },
            { "name": "Nose Fillers", "link": "/services/nose-fillers-dubai" },
            { "name": "Juvederm Fillers", "link": "/services/juvederm-fillers" },
            { "name": "Jawline Fillers", "link": "/services/jawline-fillers-dubai" },
            { "name": "Teosyal Fillers", "link": "/services/teosyal-fillers" },
            { "name": "Under Eye Fillers", "link": "/services/under-eye-fillers-dubai" }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "By preparing properly for treatment with nasolabial fold filler, patients can achieve the best-possible results with as few complications as possible.",
            "items": [
                {
                    "title": "Avoid blood thinners",
                    "desc": "Avoid taking aspirin, ibuprofen or other blood-thinning drugs for at least a week before the procedure, to minimize bruising.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Consult your doctor",
                    "desc": "This can include allergies, medications, or past cosmetic procedures.",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "No alcohol or smoking",
                    "desc": "Refrain from alcohol for 24 hours before your appointment and reduce or eliminate smoking, which can prompt increased bruising and slowed healing.",
                    "icon": "fa-solid fa-wine-glass-empty"
                },
                {
                    "title": "Hydrate",
                    "desc": "In the days before your appointment, drink lots of water, because hydrated skin heals better and allows for more optimal results.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Clean skin",
                    "desc": "Show up with your skin clean and makeup-free to reduce your risk of infection.",
                    "icon": "fa-solid fa-soap"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "This is because nasolabial fold fillers provide really dramatic results that are very gratifying for the patient. The filler is used to fill the lines itself and the volume that comes in, will shorten the depth of the lines as a result giving you a fresher and scrawnier look.",
            "items": [
                {
                    "title": "Immediate Improvement",
                    "desc": "You'll see a decrease in the depth of nasolabial folds immediately after the treatment.",
                    "icon": "fa-solid fa-face-grin"
                },
                {
                    "title": "Optimal Results",
                    "desc": "Full results are seen in about a week, after any swelling or bruising resolves.",
                    "icon": "fa-solid fa-check-double"
                },
                {
                    "title": "Temporary Results",
                    "desc": "Results generally last anywhere from 6 to 18 months, depending upon the type of filler, and you can opt for follow-up treatments as needed to keep you looking the way you want.",
                    "icon": "fa-solid fa-calendar-clock"
                },
                {
                    "title": "Minimal Downtime",
                    "desc": "You can return to normal life straight away as there is only minimal aftercare required post-treatment.",
                    "icon": "fa-solid fa-business-time"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Duties to be performed after Nasolabial Fold Filler Treatment",
            "subheading": "",
            "para": "Follow these top aftercare tips for optimal results and a smooth recovery after your nasolabial fold filler treatment:",
            "items": [
                {
                    "title": "Avoid Touching the Area",
                    "desc": "Do not touch, massage, or apply pressure to the treated area for at least 24 hours.",
                    "icon": "fa-solid fa-hand-paper"
                },
                {
                    "title": "Minimize Physical Activity",
                    "desc": "Do not do strenuous activities, such as exercise for 24 to 48 hours after the treatment to minimize your risk of swelling or bruising.",
                    "icon": "fa-solid fa-person-walking"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "Drink lots of water to keep your skin hydrated and even help the filler settle more naturally in the skin.",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "Avoid Heat Exposure",
                    "desc": "Avoid saunas, steam rooms, and too much sun for a few days, as heat can exacerbate swelling and irritation.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Use Cold Compresses",
                    "desc": "If you have slight swelling or bruising, which is normal, gently hold a cold wrap over the area for 10-15 minutes to ease inflammation.",
                    "icon": "fa-solid fa-snowflake"
                },
                {
                    "title": "Sleep with a Pillow Under the Chest",
                    "desc": "For the first night or two, sleep with your head slightly elevated to reduce swelling and to prevent any movement of the filler.",
                    "icon": "fa-solid fa-bed"
                },
                {
                    "title": "Do Not Consume Alcohol and Blood Thinners",
                    "desc": "Avoid alcohol and blood thinners such as aspirin for at least 24 hours after the procedure to minimize bruising.",
                    "icon": "fa-solid fa-ban"
                }
            ]
        },
        "faqData": {
            "heading": "",
            "subheading": "",
            "items": []
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Bafdhfnner-Image-scaled.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/masseter-botox-2.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Allergan-Botox-Treatment-in-Dubai-3.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/3.jpg"
            ]
        },
        "product": {
            "id": 111,
            "title": "Nasolabial Fold Filler Treatment",
            "price": 450,
            "description": "Smooth deep smile lines and restore youthful facial contours with our expertly administered nasolabial fold fillers using premium dermal products."
        },
    },
  "ar": {
    "url": "",
    "meta": {
        "title": "فيلر خطوط الابتسامة في دبي | عيادة إيليت بودي هوم",
        "description": "احصل على فيلر خطوط الابتسامة في دبي، علاج غير جراحي لتقليل الخطوط العميقة واستعادة بشرة شبابية. نتائج طبيعية المظهر. استشارة مجانية.",
        "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
        "canonical": "https://elitebodyhome.com/services/nasolabial-fold-filler/",
        "og": {
            "locale": "ar_AR",
            "type": "article",
            "title": "فيلر خطوط الابتسامة في دبي | عيادة إيليت بودي هوم",
            "description": "احصل على فيلر خطوط الابتسامة في دبي، علاج غير جراحي لتقليل الخطوط العميقة واستعادة بشرة شبابية. نتائج طبيعية المظهر. استشارة مجانية.",
            "url": "https://elitebodyhome.com/services/nasolabial-fold-filler/",
            "site_name": "elitebodyhome.com",
            "updated_time": "2024-12-30T10:40:43+00:00",
            "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-99.jpg",
            "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-99.jpg",
            "image_width": 1254,
            "image_height": 700,
            "image_alt": "فيلر خطوط الابتسامة",
            "image_type": "image/jpeg"
        },
        "twitter": {
            "card": "summary_large_image",
            "title": "فيلر خطوط الابتسامة في دبي | عيادة إيليت بودي هوم",
            "description": "احصل على فيلر خطوط الابتسامة في دبي، علاج غير جراحي لتقليل الخطوط العميقة واستعادة بشرة شبابية. نتائج طبيعية المظهر. استشارة مجانية.",
            "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-99.jpg"
        }
    },
    "breadcrumbs": ["الرئيسية", "الخدمات", "فيلر خطوط الابتسامة"],
    "hero": {
        "title": "فيلر خطوط الابتسامة في دبي",
        "subtitle": "ودّع خطوط الابتسامة العميقة",
        "description": "تعرف خطوط الابتسامة باسم \"الطيات الأنفية الشفوية\" أيضًا، وهي التجاعيد العميقة التي تمتد من جانبي الأنف إلى زوايا الفم. وقد تصبح هذه الخطوط أكثر وضوحًا وعمقًا مع مرور الوقت نتيجة التقدم في العمر، والتعرض لأشعة الشمس، وفقدان الكولاجين. إذا كنتِ ترغبين في تنعيم هذه الخطوط واستعادة مظهر أكثر شبابًا، فإن فيلر خطوط الابتسامة يعد إجراءً سريعًا وفعالًا يمنحكِ نتائج فورية."
    },
    "howItWorks": {
        "title": "ما هو فيلر خطوط الابتسامة؟",
        "description": "يعد فيلر خطوط الابتسامة علاجًا تجميليًا، يُحقن في الطيات الأنفية الشفوية لاستعادة الحجم المفقود وتنعيم الخطوط العميقة بها. يتكون من حمض الهيالورونيك، وهي مادة طبيعية موجودة في الجسم تساعد على ترطيب البشرة وإعطائها مظهرًا ممتلئًا. نستخدم في ايليت بودي هوم أجود أنواع الفيلر المعتمدة من قبل هيئة الغذاء والدواء الأمريكية (FDA)، مثل فيلر جوفيديرم وريستالين لضمان الحصول على نتائج دائمة ومثالية."
    },
    "procedureSteps": {
        "heading": "خطوات إجراء فيلر خطوط الابتسامة",
        "para": "",
        "steps": [
            {
                "title": "الاستشارة",
                "desc": "يقوم الأخصائي بتقييم خطوط الابتسامة لديك، وحالة بشرتك، وبنية وجهك لتحديد نوع الفيلر المناسب ووضع خطة علاجية مخصصة لكِ.",
                "icon": "fa-regular fa-comment-dots"
            },
            {
                "title": "الاستعداد",
                "desc": "تعد خطوة هامة للغاية للتأكد من نظافة المنطقة المحيطة بالطيات الأنفية الشفوية وتجنب حدوث أي عدوى، ثم يُستخدم مخدر موضعي لتقليل الشعور بالألم أثناء الإجراء.",
                "icon": "fa-regular fa-hand-sparkles"
            },
            {
                "title": "تحديد مواقع الحقن",
                "desc": "يقوم الأخصائي بتحديد النقاط المستهدفة للحقن.",
                "icon": "fa-solid fa-syringe"
            },
            {
                "title": "تدليك وتوزيع الفيلر",
                "desc": "قد يقوم الأخصائي بتدليك المنطقة بعد الحقن برفق لضمان توزيع الفيلر بشكل متناسق واندماجه بسلاسة مع ملامح الوجه الطبيعية.",
                "icon": "fa-regular fa-hand-spock"
            },
            {
                "title": "حقن الفيلر",
                "desc": "تُحقن البشرة بالفيلر بدقة عالية في المناطق المحددة باستخدام إبرة أو قنية رفيعة.",
                "icon": "fa-solid fa-syringe"
            },
            {
                "title": "التقييم النهائي",
                "desc": "يُقيم الطبيب المتخصص النتائج بعد الانتهاء من الحقن ويقوم بإجراء أي تعديلات ضرورية إن وجدت. كما سيتم تزويدك بتعليمات العناية بعد الإجراء لضمان أفضل النتائج والتعافي السليم.",
                "icon": "fa-regular fa-clipboard-check"
            }
        ]
    },
    "benefits": {
        "heading": "ما هي مزايا فيلر خطوط الابتسامة؟",
        "subheading": "",
        "para": "يمكن الحصول على فيلر خطوط الابتسامة بتكلفة مناسبة، مع فوائد تتجاوز إخفاء خطوط التجاعيد، حيث يمنح البشرة مظهرًا أكثر نضارة وشبابًا بلمسة طبيعية ولا يتطلب فترة تعافي طويلة.",
        "items": [
            {
                "title": "نتائج فورية",
                "desc": "تظهر نتائج واضحة في خطوط الابتسامة فورًا بعد الإجراء.",
                "icon": "fa-solid fa-bolt"
            },
            {
                "title": "إجراء غير جراحي",
                "desc": "يعتبر علاجًا غير جراحي بالكامل، لا يتطلب إحداث جروح أو عمليات جراحية، مع أقل وقت تعافي ممكنة.",
                "icon": "fa-solid fa-hand-holding-medical"
            },
            {
                "title": "مظهر طبيعي وشبابي",
                "desc": "يعمل الفيلر على إعادة مليء الوجه بشكل طبيعي دون مبالغة، مما يمنحك إطلالة متوازنة ومشرقة.",
                "icon": "fa-regular fa-face-smile"
            },
            {
                "title": "علاج مخصص وفقًا لاحتياجاتك",
                "desc": "يتيح هذا الإجراء تحديد ملامح الوجه بدقة، مع إمكانية توزيع الفيلر وحقنه بشكل مخصص ليتناسب مع بنية وجهك الفريدة ورغباتك.",
                "icon": "fa-solid fa-sliders"
            },
            {
                "title": "إجراء سريع",
                "desc": "يستغرق العلاج عادةً أقل من 30 دقيقة، مما يجعله مثاليًا للأشخاص الذين لديهم جدول أعمال مزدحم.",
                "icon": "fa-regular fa-clock"
            },
            {
                "title": "نتائج طويلة الأمد",
                "desc": "تختلف مدة دوام النتائج حسب نوع الفيلر المستخدم، لكنها عادةً تتراوح بين 6 إلى 18 شهرًا، مما يوفر تجديدًا للبشرة يدوم طويلًا.",
                "icon": "fa-solid fa-hourglass-end"
            }
        ]
    },
    "eligibility": {
        "heading": "من هو المرشح المناسب لفيلر خطوط الابتسامة؟",
        "subheading": "",
        "para": "على الرغم من أن فيلر خطوط الابتسامة يعد إجراءً آمنًا لمعظم الأشخاص، إلا أنه من المهم التأكد من أنك مرشح مناسب للعلاج.",
        "items": [
            {
                "title": "الأشخاص الذين يعانون من خطوط ابتسامة متوسطة إلى شديدة العمق",
                "desc": "إذا كانت التجاعيد حول الفم والأنف تشكل مصدرًا للقلق لديك، فقد يكون هذا العلاج خيارًا مناسبًا لك.",
                "icon": "fa-solid fa-face-meh"
            },
            {
                "title": "البالغون الأصحاء",
                "desc": "يجب أن يتمتع المرشح بصحة عامة جيدة، ولا يعاني من مشاكل قد تعيق عملية الشفاء.",
                "icon": "fa-solid fa-heart-pulse"
            },
            {
                "title": "الأشخاص غير المدخنين أو المستعدين للإقلاع عن التدخين",
                "desc": "يمكن أن يعيق التدخين عملية التعافي في منطقة العلاج.",
                "icon": "fa-solid fa-smoking-ban"
            },
            {
                "title": "الأشخاص الذين يمتلكون توقعات واقعية",
                "desc": "يجب أن يكون المريض على وعي أن برغم النتائج المبهرة للفيلر إلا إنها نتائج مؤقتة.",
                "icon": "fa-solid fa-scale-balanced"
            },
            {
                "title": "النساء غير الحوامل أو المرضعات",
                "desc": "يفضل تجنب حقن الفيلر أثناء الحمل أو الرضاعة، لعدم توفر بيانات كافية حول أمان استخدامه في هذه المراحل.",
                "icon": "fa-solid fa-baby-carriage"
            }
        ]
    },
    "internalLinking": {
        "heading": "اكتشف مجموعاتنا من فيلر البشرة لتعزيز جمال الوجه بالكامل",
        "items": [
            { "name": "فيلر الذقن", "link": "/services/chin-fillers-dubai" },
            { "name": "فيلر الأنف", "link": "/services/nose-fillers-dubai" },
            { "name": "فيلر جوفيديرم", "link": "/services/juvederm-fillers" },
            { "name": "فيلر خط الفك", "link": "/services/jawline-fillers-dubai" },
            { "name": "فيلر تيوسيال", "link": "/services/teosyal-fillers" },
            { "name": "فيلر تحت العين", "link": "/services/under-eye-fillers-dubai" }
        ]
    },
    "preparationTips": {
        "heading": "الاستعداد",
        "subheading": "",
        "para": "يساعد التحضير الجيد قبل حقن فيلر خطوط الابتسامة على تحقيق أفضل النتائج وتقليل أي مضاعفات محتملة.",
        "items": [
            {
                "title": "تجنب مُميعات الدم",
                "desc": "امتنع عن تناول الأسبرين أو الإيبوبروفين أو أي أدوية مميعة للدم لمدة لا تقل عن أسبوع قبل الجلسة لتجنب ظهور كدمات.",
                "icon": "fa-solid fa-pills"
            },
            {
                "title": "استشر طبيبك",
                "desc": "أخبر طبيبك إذا كنت تعاني من أي حساسية، أو إذا كنت تتناول أي أدوية، كما يجب إبلاغ الطبيب بالإجراءات التجميلية السابقة لضمان أمان العلاج.",
                "icon": "fa-solid fa-user-doctor"
            },
            {
                "title": "الامتناع عن التدخين والكحول",
                "desc": "تجنب المشروبات الكحولية لمدة 24 ساعة على الأقل قبل الجلسة، كما يجب التقليل أو الامتناع عن التدخين لأنه قد يزيد من احتمالية ظهور الكدمات ويعيق عملية التعافي.",
                "icon": "fa-solid fa-wine-glass-empty"
            },
            {
                "title": "الحفاظ على ترطيب",
                "desc": "احرص على شرب كميات كافية من الماء في الأيام التي تسبق الجلسة، حيث إن البشرة المرطبة جيدًا تتعافى بشكل أفضل وتساعد في تحقيق نتائج أكثر فعالية.",
                "icon": "fa-solid fa-glass-water"
            },
            {
                "title": "تنظيف البشرة",
                "desc": "تأكد من الحضور إلى الجلسة ببشرة نظيفة وخالية من المكياج، للحد من خطر الإصابة بأي عدوى.",
                "icon": "fa-solid fa-soap"
            }
        ]
    },
    "results": {
        "heading": "النتائج",
        "subheading": "",
        "para": "يتميز فيلر خطوط الابتسامة بنتائج مذهلة ومرضية للمريض، حيث يساعد الفيلر على ملء الخطوط مباشرة، ويعمل هذا الحشو على تقليل عمق الخطوط، مما يمنحك مظهرًا أكثر شبابًا وحيوية.",
        "items": [
            {
                "title": "تحسن فوري",
                "desc": "يُلاحظ المرضى انخفاض في عمق خطوط الابتسامة مباشرة بعد الجلسة.",
                "icon": "fa-solid fa-face-grin"
            },
            {
                "title": "نتائج مثالية",
                "desc": "تظهر النتائج النهائية للعلاج خلال أسبوع تقريبًا بعد زوال أي انتفاخ أو كدمات.",
                "icon": "fa-solid fa-check-double"
            },
            {
                "title": "نتائج مؤقتة",
                "desc": "تستمر النتائج عادة بين 6 إلى 18 شهرًا، حسب نوع الفيلر المستخدم، ويمكنك إجراء جلسات متابعة للحفاظ على المظهر المطلوب.",
                "icon": "fa-solid fa-calendar-clock"
            },
            {
                "title": "لا يتطلب فترة تعافي",
                "desc": "يمكنك العودة إلى أنشطتك اليومية فورًا بعد الجلسة مع اتباع تعليمات العناية البسيطة بعد العلاج.",
                "icon": "fa-solid fa-business-time"
            }
        ]
    },
    "aftercareTips": {
        "heading": "إرشادات العناية بعد العلاج",
        "subheading": "",
        "para": "يجب اتباع نصائح العناية بعد حقن فيلر خطوط الابتسامة لضمان أفضل النتائج والتعافي السريع.",
        "items": [
            {
                "title": "تجنّب لمس المنطقة المُعالجة",
                "desc": "لا تلمس أو تدلّك أو تضغط على المنطقة المُعالجة لمدة 24 ساعة على الأقل.",
                "icon": "fa-solid fa-hand-paper"
            },
            {
                "title": "تقليل النشاط البدني",
                "desc": "تجنب التمارين الشاقة لمدة 24 إلى 48 ساعة بعد العلاج لتقليل خطر التورم أو الكدمات.",
                "icon": "fa-solid fa-person-walking"
            },
            {
                "title": "الحفاظ على ترطيب الجسم",
                "desc": "اشرب كميات كافية من الماء للحفاظ على ترطيب البشرة والمساعدة في استقرار الفيلر بشكل طبيعي.",
                "icon": "fa-solid fa-droplet"
            },
            {
                "title": "تجنب التعرض للحرارة",
                "desc": "ابتعد عن الساونا وغرف البخار وأشعة الشمس المباشرة لبضعة أيام، حيث يمكن للحرارة أن تزيد من احتمالية التورم والتهابات.",
                "icon": "fa-solid fa-sun"
            },
            {
                "title": "استخدام الكمادات الباردة",
                "desc": "استخدم كمادات باردة على المنطقة لمدة 10-15 دقيقة في حالة حدوث تورم أو كدمات طفيفة لتخفيف الالتهاب.",
                "icon": "fa-solid fa-snowflake"
            },
            {
                "title": "استخدام وسادة أسفل الصدر للنوم",
                "desc": "يُفضل النوم مع رفع الرأس خلال أول ليلتين لتقليل التورم ومنع تحرك الفيلر.",
                "icon": "fa-solid fa-bed"
            },
            {
                "title": "الامتناع عن الكحول ومميعات الدم",
                "desc": "تجنب المشروبات الكحولية والأدوية المميعة للدم مثل الأسبرين لمدة 24 ساعة على الأقل بعد الإجراء لتقليل خطر الكدمات.",
                "icon": "fa-solid fa-ban"
            }
        ]
    },
    "faqData": {
        "heading": "",
        "subheading": "",
        "items": []
    },
    "treatmentAreas1": [],
    "treatmentAreas2": []
}
};
